import {
	Nfc,
	NfcUtils as Utils,
	NfcTagTechType as TagTechType,
} from '@capawesome-team/capacitor-nfc';
import mitt from 'mitt';

// plugin's methods
const methods = [
	'startScanSession',
	'stopScanSession',
	'write',
	'makeReadOnly',
	'erase',
	'format',
	'transceive',
	'connect',
	'close',
	'isSupported',
	'isEnabled',
	'openSettings',
	'getAntennaInfo',
	'setAlertMessage',
	'checkPermissions',
	'requestPermissions',
];

// plugin's listeners
const emitter = mitt();
const events = [
	'nfcTagScanned',
	'scanSessionCanceled',
	'scanSessionError',
];

Nfc.removeAllListeners();

events.forEach(event => {
	Nfc.addListener(event, data => {
		console.log(`event [${event}]: `, data);
		emitter.emit(event, data);
	});
});

export function useNativeNfc () {
	// api methods
	const api = methods.reduce((api, name) => {
		api[name] = Nfc[name];
		return api;
	}, {});

	// custom add listener
	function addListener (event, callback) {
		emitter.on(event, callback);
		return () => emitter.off(event, callback);
	}

	// custom remove listener
	function removeListener (event, callback) {
		emitter.off(event, callback);
	}

	// custom remove all listeners
	function removeAllListeners () {
		emitter.all.clear();
	}

	return {
		...api,
		addListener,
		removeListener,
		removeAllListeners,
	};
}

export const NfcUtils = Utils;
export const NfcTagTechType = TagTechType;
